import { removeEndingStartingWith } from "./utils/utils";

export interface ApplicationCardConfig {
  title?: string;
  description?: string;
  icon: string;
  iconColor: string;
  searchTerms: string[];
  isExternal?: boolean;
  hasSearch?: boolean;
  fordDirectOnly?: boolean;
  hrefLabelKey?: string;
  descriptionLabelKey?: string;
  titleLabelKey?: string;
  transformUrl?: (url: string) => string;
  appendParams?: string;
  skipLang?: boolean;
  appendAccountIdParam?: string;
  fallbackSearchTerms?: string[];
  excludeSearchTerms?: string[];
  requiredPermission?: string;
}

export const applicationCardData: ApplicationCardConfig[] = [
  {
    titleLabelKey: "SOCIAL_MEDIA",
    descriptionLabelKey: "WELCOME-DASHBOARD-DESC-SOCIAL_MEDIA",
    icon: "textsms",
    iconColor: "#668EF0",
    searchTerms: ["SmartBlog Compose"],
    fallbackSearchTerms: ["/social/"],
    skipLang: true
  },
  {
    titleLabelKey: "WEBSITE",
    descriptionLabelKey: "WELCOME-DASHBOARD-DESC-WEBSITE",
    icon: "phonelink",
    iconColor: "#E87722",
    searchTerms: ["WEBSITE_EDITOR||"],
    fallbackSearchTerms: ["/website"],
    excludeSearchTerms: ["/distributionList/"],
    appendParams: "__ssuMode=true",
    transformUrl: url => url.replace(/(\/as\/[^/]+\/[^/]+).*$/, "$1"),
    requiredPermission: "WEBSITE"
  },
  {
    titleLabelKey: "INVENTORY",
    descriptionLabelKey: "WELCOME-DASHBOARD-DESC-INVENTORY",
    icon: "directions_car",
    iconColor: "#009E77",
    searchTerms: ["/im10/"],
    fallbackSearchTerms: ["manage/index"],
    excludeSearchTerms: ["search="],
    hasSearch: true,
    transformUrl: url =>
      url.replace(/(\/inventory(?:\/as\/[^/]+\/[^/]+)?).*$/, "$1/im10")
  },
  {
    titleLabelKey: "LEADS",
    descriptionLabelKey: "WELCOME-DASHBOARD-DESC-LEADS",
    icon: "contact_mail",
    iconColor: "#C86CD0",
    searchTerms: ["/leads/", "/nav/index#all"]
  },
  {
    titleLabelKey: "CONFIGURATION",
    descriptionLabelKey: "WELCOME-DASHBOARD-DESC-CONFIGURATION",
    icon: "settings_applications",
    iconColor: "#7C8696",
    searchTerms: ["Company Information||"],
    fallbackSearchTerms: ["/manage/myinfo"],
    transformUrl: url => removeEndingStartingWith(url, "/manage")
  },
  {
    titleLabelKey: "INCENTIVES_MANAGER",
    descriptionLabelKey: "WELCOME-DASHBOARD-DESC-INCENTIVES_MANAGER",
    icon: "car_tag",
    iconColor: "#3996D4",
    searchTerms: ["New Incentives Manager"],
    fallbackSearchTerms: ["Incentives Manager||"],
    transformUrl: url =>
      url.replace(
        /^(https?:\/\/[^/]+)\/inventory(\/as\/[^/]+\/[^/]+).*$/,
        "$1/landing/cc$2/incentivesManager"
      )
  },
  {
    titleLabelKey: "SPECIALS_CAMPAIGNS",
    descriptionLabelKey: "WELCOME-DASHBOARD-DESC-SPECIALS_CAMPAIGNS",
    icon: "photo_size_select_large",
    iconColor: "#17a2b8",
    searchTerms: ["Manage||", "/promotions"]
  },
  {
    titleLabelKey: "NVISION_ANALYZE",
    descriptionLabelKey: "WELCOME-DASHBOARD-DESC-NVISION_ANALYZE",
    icon: "timeline",
    iconColor: "#F8CC00",
    searchTerms: ["nVision Analyze"],
    fallbackSearchTerms: ["/analytics/"],
    isExternal: true,
    skipLang: true,
    appendAccountIdParam: "svocAccountId"
  },
  {
    titleLabelKey: "MARCHEX",
    descriptionLabelKey: "WELCOME-DASHBOARD-DESC-MARCHEX",
    icon: "phone",
    iconColor: "#454545",
    searchTerms: [],
    hrefLabelKey: "MARCHEX_HREF_LABEL",
    isExternal: true,
    fordDirectOnly: true,
    skipLang: true
  }
];
